import { redirectToSandbox } from "./redirectToSandbox";

/**
 * Where a flow's way out leads (its "Go back", success countdown, "Go to Student Portal").
 *
 * A student who arrives from standalone Sandbox (Edit class, View schedules, Add a class on
 * Sandbox's homepage) should land back there, not on the portal's dashboard. The auth bridge
 * marks that arrival for the tab; opening the portal's own dashboard clears the mark, because
 * from then on the student is using the portal.
 */
const RETURN_KEY = "_cy_return_to_sandbox";
const DASHBOARD_PATH = "/dashboard";

// sessionStorage throws when the browser blocks site data; then there is no mark.
export const rememberSandboxReturn = () => {
  try {
    sessionStorage.setItem(RETURN_KEY, "1");
  } catch (_) {}
};

export const forgetSandboxReturn = () => {
  try {
    sessionStorage.removeItem(RETURN_KEY);
  } catch (_) {}
};

export const isReturningToSandbox = () => {
  try {
    return sessionStorage.getItem(RETURN_KEY) === "1";
  } catch (_) {
    return false;
  }
};

/** The name of where leaving goes, for copy: "Sandbox", or the portal name the screen already uses. */
export const homeName = (portalName) => (isReturningToSandbox() ? "Sandbox" : portalName);

/** The arrow button that leaves a finished flow. */
export const leaveButtonLabel = () =>
  isReturningToSandbox() ? "Go back to Sandbox →" : "Go to Student Portal →";

/** Opening the portal's own dashboard means the student is using the portal now: drop the mark. */
export const forgetSandboxReturnOnDashboard = (pathname) => {
  if (pathname === DASHBOARD_PATH) forgetSandboxReturn();
};

/** Leave the flow: back to Sandbox's homepage after a Sandbox arrival, otherwise the dashboard. */
export const leaveForHome = (history) => {
  if (isReturningToSandbox()) redirectToSandbox("/home");
  else history.push(DASHBOARD_PATH);
};
